import { ReportColumn } from '@contracts';

export const DEFAULT_REPORT_COLUMNS: ReportColumn[] = [
  {
    key: 'no',
    label: 'view_value.no',
    type: 'text',
    sortable: false,
    visible: true,
    exportable: true,
    valueGetter: (_row, index, pageIndex, pageSize) =>
      pageIndex * pageSize + index + 1,
  },
  {
    key: 'name',
    label: 'view_value.meter_name',
    field: 'name',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
    widthClass: 'w-180',
  },
  {
    key: 'tenant',
    label: 'view_value.tenant',
    field: 'shop_name',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
    widthClass: 'w-180',
  },
  {
    key: 'room',
    label: 'view_value.location_tier_5',
    field: 'room',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
    widthClass: 'w-180',
  },
  {
    key: 'serial_number',
    label: 'view_value.serial_number',
    field: 'serial_number',
    type: 'text',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'previous_reading',
    // label: 'เลขครั้งก่อน',
    label: 'view_value.previous_reading',
    field: 'previous_reading',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 0,
      maxFractionDigits: 0,
    },
  },
  {
    key: 'date_previous_reading',
    // label: 'เวลาครั้งก่อน',
    label: 'view_value.date_previous_reading',
    field: 'date_previous_reading',
    type: 'datetime',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'recent_reading',
    // label: 'เลขครั้งหลัง',
    label: 'view_value.recent_reading',
    field: 'recent_reading',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 0,
      maxFractionDigits: 0,
    },
  },
  {
    key: 'date_recent_reading',
    // label: 'เวลาครั้งหลัง',
    label: 'view_value.date_recent_reading',
    field: 'date_recent_reading',
    type: 'datetime',
    sortable: true,
    visible: true,
    exportable: true,
  },
  {
    key: 'consumption',
    // label: 'จำนวนที่ใช้ไป',
    label: 'view_value.consumption',
    field: 'consumption',
    type: 'number',
    sortable: true,
    visible: true,
    exportable: true,
    decimal: {
      minIntegerDigits: 1,
      minFractionDigits: 0,
      maxFractionDigits: 0,
    },
  },
  // {
  //   key: 'consumption_status',
  //   // label: 'สถานะ',
  //   label: 'view_value.status',
  //   field: 'consumption_status',
  //   type: 'status',
  //   sortable: true,
  //   visible: true,
  //   exportable: true,
  // },
  {
    key: 'downloadCsv',
    // label: 'ดาวน์โหลด Excel',
    label: 'view_value.download_excel',
    type: 'action',
    sortable: false,
    visible: true,
    exportable: false,
  },
];
